import { IconLoader } from 'common/IconLoader';

export const createPolygonTypes = [
	{
		name: 'Custom',
		geometry: 'Polygon',
		icon: IconLoader.icon_polygon_creation,
		iconHover: IconLoader.icon_polygon_creation_hover
	},
	{
		name: 'Rectangle',
		geometry: 'Rectangle',
		icon: IconLoader.icon_rectangle_creation,
		iconHover: IconLoader.icon_rectangle_creation_hover
	}
];

export const polygonFillOpacity = {
	hover: 0.06,
	active: 0.12
};

export const ROWS_HEIGHT = 264;

export const DEFAULT_LIST_STYLE = {
	maxHeight: ROWS_HEIGHT + 'px'
};

export const MAP_CONTROL_POPUP_CORRECTION = 110;

export const LIST_ITEM_HEIGHT = 44;

export const OPTIONS_POP_UP_ITEMS_LIST = ['edit', 'duplicate', 'export', 'delete'];

export const OPTIONS_POP_UP_POSITION_X_CORRECTION = 100;

export const EMPTY_POLYGON_LIST_MESSAGE = 'Draw a new Polygon or Import a Polygon';